import MessageBoxLayoutBase from "./MessageBoxLayout/MessageBoxLayoutBase/MessageBoxLayoutBase";
import MessageBoxLayoutContent from "./MessageBoxLayout/MessageBoxLayoutContent/MessageBoxLayoutContent";
import { PropsMessageBoxLayout } from "./modelsMessageBox";

export const creatorWindowMessageBox = ({
    textContent,
    stateWindow,
    actionButtons,
    handleClose,
    caption: captionButtons,
}: PropsMessageBoxLayout) => {
    return (
        <MessageBoxLayoutBase
            captionButtons={captionButtons}
            handleClose={handleClose}
            stateWindow={stateWindow}
        >
            <MessageBoxLayoutContent
                stateWindow={stateWindow}
                actionButtons={actionButtons}
                textContent={textContent}
            />
        </MessageBoxLayoutBase>
    );
};
